import { DynamicLinksBlockProps } from 'sly/hubPage/components/HubDynamicContent/DynamicLinksBlock/DynamicLinksBlock.types';
import Heading from 'sly/system/Heading';

export default function DynamicLinksBlock({
  title,
  description,
  links,
}: DynamicLinksBlockProps) {
  return (
    <div
      className='mx-m mb-l w-[calc(100%-2rem)] md:mx-auto md:mb-xl md:w-[var(--col6)] lg:w-[var(--col8)]'
      data-tp-id='gen-div-32ac1782-33da-4cc6-9fcb-41971d74f8a8'
    >
      <div
        className='rounded bg-viridian-lighter-90 p-l md:p-xl'
        data-tp-id='gen-div-27444939-5262-4f69-ad6b-cbb2ba38f401'
      >
        <Heading
          font='font-t-l'
          className='font-t-l mb-xl'
          data-tp-id='gen-Heading-981371c7-d7ea-4e42-9f38-2ed3b52308ab'
        >
          {title}
        </Heading>
        <Heading
          font='font-b-l'
          className='font-b-l mb-l md:mb-xl lg:mb-l'
          data-tp-id='gen-Heading-bdb4920f-6d5f-4cca-b925-b26339b4bc74'
        >
          {description}
        </Heading>
        {links?.map(({ to, title: linksTitle, id }) => (
          <a
            key={id}
            href={to}
            className='font-b-l mb-l mb-m block text-viridian-base last:mb-0 hover:underline md:mb-xl lg:mb-l'
          >
            {linksTitle}
          </a>
        ))}
      </div>
    </div>
  );
}
